import ApiService from 'src/shared/utils/base-api/api-service';
import {ResponseDto} from 'src/shared/common-dtos/response-dto';
import {UserDeatilsDto} from './dto/details-user-dto';
import {DataListDto} from 'src/shared/common-dtos/data-list-dto';
import {EditUserPermissions} from './dto/update-user-roles-dto';
import {CreateOrUpdateUserDto} from './dto/create-or-update-user-dto';
import {ParamsDto} from 'src/shared/common-dtos/params-dto';

class UsersManagementService extends ApiService {
  constructor() {
    super({
      baseURL: '/User',
    });
  }
  public getAllUsers(
    input: ParamsDto | undefined,
    userType: Array<number>,
  ): Promise<ResponseDto<DataListDto<UserDeatilsDto>>> {
    const userTypeQuery = userType
      .map((value) => {
        return `userType=${value}`;
      })
      .join('&');
    return this.get(`/GetAll?${userTypeQuery}`, {
      params: input,
    });
  }

  public getUserDetails(userId: string): Promise<ResponseDto<UserDeatilsDto>> {
    return this.get(`/GetDetails/${userId}`);
  }

  public getMyProfile(): Promise<ResponseDto<UserDeatilsDto>> {
    return this.get('/GetMyProfile');
  }

  public createUser(
    input: CreateOrUpdateUserDto,
  ): Promise<ResponseDto<UserDeatilsDto>> {
    return this.post('/AddUser', input);
  }

  public updateUserProfile(
    input: CreateOrUpdateUserDto,
  ): Promise<ResponseDto<UserDeatilsDto>> {
    return this.put('/UpdateUserProfile', input);
  }

  public deleteUser(userId: string): Promise<ResponseDto<UserDeatilsDto>> {
    return this.delete(`/DeleteUser/${userId}`);
  }
  public editUserPermissions(
    input: EditUserPermissions,
  ): Promise<ResponseDto<UserDeatilsDto>> {
    return this.post('/EditUserPermissions', input);
  }

  public activateDeactivateUser(
    userId: string,
  ): Promise<ResponseDto<UserDeatilsDto>> {
    return this.put(`/ArchiveUser/${userId}`);
  }

  public sendPasswordResetEmail(userId: string): Promise<ResponseDto<void>> {
    return this.post(`/SendPasswordResetEmail/${userId}`);
  }

  public updatePlannerContractorInfo(
    userId: string,
    input: {isContractor: boolean; fee?: number},
  ): Promise<ResponseDto<void>> {
    return this.put(`/UpdatePlannerContractorInfo/${userId}`, input);
  }

  public getUsersByIds(ids: string[]): Promise<ResponseDto<UserDeatilsDto[]>> {
    return this.post('/GetByIds', ids);
  }
}

export const usersManagementService = new UsersManagementService();
